export const COMMANDE_CREER_SUCCES = "COMMANDE_CREER_SUCCES";
export const COMMANDE_CREER_ECHEC = "COMMANDE_CREER_ECHEC";
export const COMMANDE_CREER_RESET = "COMMANDE_CREER_RESET";
export const COMMANDE_LISTE_CLI_SUCCES = "COMMANDE_LISTE_CLI_SUCCES";
export const COMMANDE_LISTE_CLI_ECHEC = "COMMANDE_LISTE_CLI_ECHEC";
export const COMMANDE_DETAILS_REQUETTE = "COMMANDE_DETAILS_REQUETTE";

export const COMMANDE_DETAILS_SUCCES = "COMMANDE_DETAILS_SUCCES";
export const COMMANDE_DETAILS_ECHEC = "COMMANDE_DETAILS_ECHEC";

export const COMMANDE_LISTE_CODE_SUCCES = "COMMANDE_LISTE_CODE_SUCCES";
export const COMMANDE_LISTE_CODE_ECHEC = "COMMANDE_LISTE_CODE_ECHEC";

export const COMMANDE_LISTE_REP_REQUETTE = "COMMANDE_LISTE_REP_REQUETTE";
export const COMMANDE_LISTE_REP_SUCCES = "COMMANDE_LISTE_REP_SUCCES";
export const COMMANDE_LISTE_REP_ECHEC = "COMMANDE_LISTE_REP_ECHEC";

export const COMMANDE_TOUS_SUCCES = "COMMANDE_TOUS_SUCCES";
export const COMMANDE_TOUS_ECHEC = "COMMANDE_TOUS_ECHEC";
export const COMMANDE_TOUS_REQUETTE = "COMMANDE_TOUS_REQUETTE";

export const VENTE_RAPPORT_SUCCES = "VENTE_RAPPORT_SUCCES";
export const VENTE_RAPPORT_ECHEC = "VENTE_RAPPORT_ECHEC";
export const VENTE_RAPPORT_REQUETTE = "VENTE_RAPPORT_REQUETTE";
